import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { useLanguage } from '../lib/i18n';
const faqs = [{
  qKey: 'faq.q1',
  aKey: 'faq.a1'
}, {
  qKey: 'faq.q2',
  aKey: 'faq.a2'
}, {
  qKey: 'faq.q3',
  aKey: 'faq.a3'
}, {
  qKey: 'faq.q4',
  aKey: 'faq.a4'
}, {
  qKey: 'faq.q5',
  aKey: 'faq.a5'
}, {
  qKey: 'faq.q6',
  aKey: 'faq.a6'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  const {
    t
  } = useLanguage();
  return <section id="faq" className="py-16 sm:py-24 lg:py-32 px-5 sm:px-8 lg:px-24 bg-sand w-full overflow-hidden" data-id="element-98" data-mp="203jd3twz7ngn">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-24 max-w-[1400px] mx-auto" data-id="element-99" data-mp="1v46ekbwqsry8">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 1.2,
        ease: [0.22, 1, 0.36, 1]
      }} className="lg:col-span-5" data-id="element-100" data-mp="opys3ey29ddh">
          <p className="uppercase tracking-[0.3em] text-olive text-[9px] sm:text-[10px] font-semibold mb-4 sm:mb-6" data-id="element-101" data-mp="1aor8vw4gvgdu">
            {t('faq.tag')}
          </p>
          <h2 className="font-display text-fluid-h2 text-volcanic font-light leading-[1.1] mb-6 sm:mb-10" data-id="element-102" data-mp="11xij39wh99qz">
            {t('faq.title1')} <br data-id="element-103" data-mp="16p0lm2e5fie2" />
            <span className="font-script text-fluid-script text-terracotta inline-block mt-[-0.1em]" data-id="element-104" data-mp="16pieqq5ilghr">
              {t('faq.title2')}
            </span>
          </h2>
          <p className="text-[14px] sm:text-[15px] leading-relaxed text-volcanic/80 max-w-md font-light" data-id="element-105" data-mp="wxmcr40b5689">
            {t('faq.desc')}
          </p>
        </motion.div>

        <div className="lg:col-span-7" data-id="element-106" data-mp="j0qvwpdteahn">
          {faqs.map((item, index) => {
          const isOpen = open === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.8,
            delay: index * 0.1,
            ease: [0.22, 1, 0.36, 1]
          }} className="border-b border-beige" data-id="element-107" data-mp="2pnop8rnhbuuj" data-mpi={index}>
                <button onClick={() => setOpen(isOpen ? null : index)} className="w-full flex items-center justify-between gap-4 sm:gap-6 py-5 sm:py-7 lg:py-8 text-left group" data-id="element-108" data-mp="2yma2q8e3gjog">
                  <span className={`font-display text-xl sm:text-2xl lg:text-3xl transition-colors duration-300 font-light pr-4 ${isOpen ? 'text-terracotta' : 'text-volcanic group-hover:text-terracotta'}`} data-id="element-109" data-mp="1n61ze4qu94bq">
                    {t(item.qKey)}
                  </span>
                  <span className={`flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center border transition-all duration-500 ${isOpen ? 'bg-terracotta border-terracotta text-ivory rotate-180' : 'border-beige text-volcanic group-hover:border-terracotta group-hover:text-terracotta'}`} data-id="element-110" data-mp="2o15tymh7jf7">
                    {isOpen ? <MinusIcon size={16} strokeWidth={1.5} className="sm:w-[18px] sm:h-[18px]" data-id="element-111" data-mp="mca32n2vmflk" /> : <PlusIcon size={16} strokeWidth={1.5} className="sm:w-[18px] sm:h-[18px]" data-id="element-112" data-mp="vcf50hpawlsc" />}
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-113" data-mp="21ueotaypi8qx">
                  {isOpen && <motion.div key="content" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.6,
                ease: [0.22, 1, 0.36, 1]
              }} className="overflow-hidden" data-id="element-114" data-mp="1wvv39bo0yyz3">
                      <p className="text-[13px] sm:text-[15px] leading-relaxed text-volcanic/80 pb-6 sm:pb-8 pr-8 sm:pr-12 max-w-2xl font-light" data-id="element-115" data-mp="10egusgud7go3">
                        {t(item.aKey)}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}